module.exports = __webpack_public_path__ + "static/header-2-3263d08d1b97a004cca6dcf8e3a5ac60.png";